export default __webpack_public_path__ + "static/media/Output_ToScreen.1814785a.svg";